import React, { createContext, useContext, useState, ReactNode, useCallback } from 'react';

type OverlayRenderFn = () => React.ReactElement;

interface OverlayContextType {
  open: (fn: OverlayRenderFn) => void;
  close: () => void;
}

const OverlayContext = createContext<OverlayContextType | undefined>(undefined);

export const OverlayProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [stack, setStack] = useState<OverlayRenderFn[]>([]);

  const open = useCallback((fn: OverlayRenderFn) => {
    setStack((prev) => [...prev, fn]);
  }, []);

  const close = useCallback(() => {
    setStack((prev) => prev.slice(0, -1));
  }, []);

  return (
    <OverlayContext.Provider value={{ open, close }}>
      {children}
      {stack.map((fn, idx) => (
        <React.Fragment key={idx}>{fn()}</React.Fragment>
      ))}
    </OverlayContext.Provider>
  );
};

export function useOverlay() {
  const ctx = useContext(OverlayContext);
  if (!ctx) throw new Error('useOverlay must be used within OverlayProvider');
  return ctx;
}